export default "/static/images/schoorsteen_1.png?3af98d8ccfc30460bdb66a3e5779343d";